const FORMAT_PATTERNS = {
  phone: 'PREFIX [0000000000000000000]',
  date: '1111/11/11',
  currency: '$0,0.00',
  currencyDollar: '$0,0.00'
};

export default FORMAT_PATTERNS;
